import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BalanceCuentaTrabajo } from '../interfaces/balance-cuenta-trabajo.interface';

@Injectable({
  providedIn: 'root',
})
export class BalanceCuentaTrabajoService {
  API_URL = environment.apiGatewayURL;
  constructor(private http: HttpClient) {}

  async createBalanceCuentaTrabajo(body: { cuentaTrabajoId: number; balance: number }) {
    const serviceURL = `${this.API_URL}balance/cuenta-trabajo`;
    return firstValueFrom(
      this.http.post<BalanceCuentaTrabajo>(serviceURL, body)
    );
  }

  async updateCounterBalanceCuentaTrabajo(body: { cuentaTrabajoId: number }) {
    const serviceURL = `${this.API_URL}balance/cuenta-trabajo/update-counter`;
    return firstValueFrom(
      this.http.post<BalanceCuentaTrabajo>(serviceURL, body)
    );
  }

  async getBalanceCuentaTrabajo(cuentaTrabajoId: number) {
    const serviceURL = `${this.API_URL}balance/cuenta-trabajo/${cuentaTrabajoId}`;
    return firstValueFrom(this.http.get<BalanceCuentaTrabajo>(serviceURL));
  }
}
